import TranslateIntoMenuItem from './translate_into_menu_item';

export default TranslateIntoMenuItem;
